import type { PropsWithChildren, ReactNode } from 'react';
import type { DataScope } from '@/core/types/auth';
import { useAuthStore } from '@/core/auth/authStore';
import { hasPermission } from '@/core/auth/permissions';

interface PermissionGuardProps extends PropsWithChildren {
  permission: string;
  minimumScope?: DataScope;
  fallback?: ReactNode;
}

export const PermissionGuard = ({
  permission,
  minimumScope,
  fallback = null,
  children,
}: PermissionGuardProps): React.ReactElement | null => {
  const permissions = useAuthStore((state) => state.permissions);
  return hasPermission(permissions, permission, minimumScope) ? <>{children}</> : <>{fallback}</>;
};
